import { Box, BoxProps } from "@chakra-ui/react";
import { useEffect, useRef } from "react";

type Props = { id: string; autoplay: boolean; backgroundMode: boolean; muted: boolean; containerStyles?: BoxProps }

const TrailerYouTube = ({ id, autoplay, backgroundMode, muted, containerStyles }: Props) => {
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (!ref.current) return
    const params = new URLSearchParams({
      autoplay: autoplay ? "1" : "0",
      // Start muted only in background; focused starts unmuted to avoid policy issues
      mute: backgroundMode ? "1" : "0",
      rel: "0",
      modestbranding: "1",
      showinfo: "0",
      controls: backgroundMode ? "0" : "1",
      disablekb: "0",
      fs: "1",
      iv_load_policy: "3",
      cc_load_policy: "0",
      enablejsapi: "1",
      origin: typeof window !== "undefined" ? window.location.origin : "",
      playsinline: "1",
      loop: backgroundMode ? "1" : "0"
    })
    if (backgroundMode) params.set("playlist", id)
    const html = `<iframe width=\"100%\" height=\"100%\" src=\"https://www.youtube.com/embed/${id}?${params.toString()}\" frameborder=\"0\" allow=\"accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture\" allowfullscreen></iframe>`
    ref.current.innerHTML = html
  }, [id, autoplay, backgroundMode])

  useEffect(() => {
    const iframe = ref.current?.querySelector("iframe") as HTMLIFrameElement | null
    if (!iframe) return
    try {
      const cmd = JSON.stringify({ event: "command", func: muted ? "mute" : "unMute", args: [] })
      iframe.contentWindow?.postMessage(cmd, "*")
      if (!backgroundMode && !muted) {
        const play = JSON.stringify({ event: "command", func: "playVideo", args: [] })
        iframe.contentWindow?.postMessage(play, "*")
      }
    } catch (_) {}
  }, [muted, backgroundMode])

  return (
    <Box
      ref={ref}
      position="relative"
      sx={{ aspectRatio: "16/9", iframe: { width: "100%", height: "100%", border: "none" } }}
      {...containerStyles}
    />
  )
}

export default TrailerYouTube
